const toastDuration = 3000;
export default toastDuration;